export default __webpack_public_path__ + "static/media/files-copy.c8e242df.svg";